import { Field } from 'formik'
import FieldWrapper from './../../FieldWrapper'
import WrapperAccordion from '../../../general/WrapperAccordion'
import ImageDisplayAndUpload from '../ImageDisplayAndUpload'
import Translation from '../../../Translation/cont/Translation'
import ImagesMovieDisplayAndUpload from '../ImagesMovieDisplayAndUpload'
import SourceField from '../SourceField'
import { ORIGIN_TMDB, ORIGIN_DATA_PROVIDER, ORIGIN_PM } from '../../../../constants/metaMovieOrigins'

const ImagesAccordion = ({values, activeTabClass, setActiveTab, title, classes, setMovieImages, onImagesTouched, metaData, isTmdbLinked, hasProviderMovie, onSetOrigin}) => {
    const hasPoster = values.movie.images.poster.url ? true : false
    const hasPosterId = values.movie.images.poster.id ? true : false

    const posterSources = [
        ...(isTmdbLinked ? [ORIGIN_TMDB] : []),
        ...(hasProviderMovie ? [ORIGIN_DATA_PROVIDER] : []),
        ORIGIN_PM,
    ]
    const posterOrigin = metaData && metaData.poster

    const posterHasPosition = values.movie.images.poster.positionX !== undefined || values.movie.images.poster.positionY !== undefined
    const showSliders = hasPoster && posterHasPosition && (!posterOrigin || posterOrigin === ORIGIN_PM)

    return (
        <WrapperAccordion
            title={title}
            className={classes}
            selectionActiveClass={activeTabClass}
            collapseActiveSelection={setActiveTab}
            gapless={true}
        >
            <fieldset>
                <div className="form-content">
                    <div className="left-sections">
                        <FieldWrapper classes="field-wrapper-image-accordion" wrapperClasses="image-wrapper" label={<Translation id="images_movie_poster"/>} id="movie-poster" >
                            <Field
                                name="movie.images.poster"
                                imageType="poster"
                                component={ImageDisplayAndUpload}
                                autoUpload={true}
                                />
                            {metaData && onSetOrigin && (
                                <SourceField
                                    metaKey="poster"
                                    metaValue={posterOrigin}
                                    sources={posterSources}
                                    onSetOrigin={onSetOrigin}
                                />
                            )}
                            {showSliders && <>
                                <p className='text-small-light'><Translation id={'y-axis'}/></p>
                                <div className="slidecontainer">
                                    <Field name="movie.images.poster.positionY">
                                        {({ field, form }) => (
                                            <input
                                                type="range" step="1" min="0" max="100"
                                                className="text-regular range-slider input-text-box gap-10"
                                                value={field.value !== undefined && field.value !== null && field.value !== '' ? field.value : 0}
                                                onChange={(event) => form.setFieldValue(field.name, parseInt(event.target.value))}
                                            />
                                        )}
                                    </Field>
                                </div>
                                <p className='text-small-light'><Translation id={'x-axis'}/></p>
                                <div className="slidecontainer">
                                    <Field name="movie.images.poster.positionX">
                                        {({ field, form }) => (
                                            <input
                                                type="range" step="1" min="0" max="100"
                                                className="text-regular range-slider input-text-box"
                                                value={field.value !== undefined && field.value !== null && field.value !== '' ? field.value : 50}
                                                onChange={(event) => form.setFieldValue(field.name, parseInt(event.target.value))}
                                            />
                                        )}
                                    </Field>
                                </div>
                            </>}
                        </FieldWrapper>
                    </div>

                    <div className="right-sections">
                        <div className="right-sections">
                            <FieldWrapper description={<Translation id="images_movie_wallpapers_info"/>} label={<Translation id="images_movie_wallpapers"/>} id="movie-backgrounds" classes="image-displaygrid-upload" >
                                <Field
                                    name="movie.images"
                                    imageType="background"
                                    component={ImagesMovieDisplayAndUpload}
                                    setMovieImages={setMovieImages}
                                    onImagesTouched={onImagesTouched}
                                    autoUpload={true}
                                />
                            </FieldWrapper>
                        </div>
                    </div>
                </div>
            </fieldset>
        </WrapperAccordion>
    )
}

export default ImagesAccordion